import { render } from "./DragAndDropZone.vue?vue&type=template&id=4d22908c&scoped=true&ts=true"
import script from "./DragAndDropZone.vue?vue&type=script&lang=ts"
export * from "./DragAndDropZone.vue?vue&type=script&lang=ts"

import "./DragAndDropZone.vue?vue&type=style&index=0&id=4d22908c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d22908c"]])

export default __exports__